















import Vue from 'vue'
import Nav from '@/components/Nav.vue'

export default Vue.extend({
  components: { Nav },
  data() {
    return {
      announcementHtml: '',
      videoUrl: '',
    }
  },
  computed: {
    embedUrl(): string | null {
      return this.getVideoUrl(this.videoUrl)
    },
  },
  mounted() {
    this.$api.get('/announcements/config').then((response) => {
      this.announcementHtml = response.data?.data?.html?.trim() || ''
      this.videoUrl = response.data?.data?.videoUrl?.trim() || ''
    })
  },
  methods: {
    getVideoUrl(url: string | undefined): string | null {
      if (!url?.trim()) return null

      const driveFileMatch = url.match(/drive\.google\.com\/file\/d\/([^/?]+)/)
      if (!driveFileMatch) return url

      const fileId = driveFileMatch[1]
      return `https://drive.google.com/file/d/${fileId}/preview`
    },
  },
})
